export default "__VITE_ASSET__c93353ba__"